import { render, staticRenderFns } from "./thead.vue?vue&type=template&id=5efc3ea4&"
import script from "./thead.vue?vue&type=script&lang=js&"
export * from "./thead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports